import UploadForm from "../components/contents/Gallery/UploadForm";

const GalleryUpload = () => {
  return <UploadForm />;
};

export default GalleryUpload;
